import React, { useEffect } from 'react';

import Edit from './Edit';
// import View from './View';

const LandingPage = (props) => {
  const {
    personal,
    fetchLandingPage,
    fetchOptionList,
    cleanOptions,
    cleanLandingPage,
    cleanCustomField,
    fetchApplicationStatus,
  } = props;

  useEffect(() => {
    fetchOptionList('Branch', 'BranchList');
    fetchOptionList('COUNTRY', 'countryList');
    fetchOptionList('customerAccountScheme', 'customerAccountSchemeList');
    return () => {
      cleanOptions();
      // cleanLandingPage();
      // cleanCustomField();
    };
  }, []);

  // return <>{personal?.locked ? <View {...props} /> : <Edit {...props} />}</>;
  return (
    <>
      <Edit {...props} />
    </>
  );
};

export default LandingPage;
